import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/app/layouts/default.vue").then(m => m.default || m)),
  "health-check": defineAsyncComponent(() => import("/usr/src/app/app/layouts/healthCheck.vue").then(m => m.default || m)),
  "menu-free": defineAsyncComponent(() => import("/usr/src/app/app/layouts/menuFree.vue").then(m => m.default || m)),
  "team-and-player": defineAsyncComponent(() => import("/usr/src/app/app/layouts/teamAndPlayer.vue").then(m => m.default || m))
}